import type { NumericField as NumericFieldType } from '@certhon/models';
import { useListContext, useFieldActions } from '../context';
import { AnnotationIndicators } from './AnnotationIndicators';
import { FieldFeedbackBadge } from '@/features/feedback/components/FieldFeedbackBadge';
import { FieldTitle } from './FieldTitle';
import { FieldWrapper } from './FieldWrapper';
import { NumericControl } from './NumericControl';

interface NumericFieldProps {
  field: NumericFieldType;
  isActive?: boolean;
  isEven?: boolean;
  onSelect?: (fieldId: string) => void;
}

export function NumericField({
  field,
  isActive,
  isEven,
  onSelect,
}: NumericFieldProps) {
  const { mode } = useListContext();
  const actions = useFieldActions(field.id);

  const disabled = mode === 'view';

  const unit = field.unit;

  return (
    <FieldWrapper
      fieldId={field.id}
      isActive={isActive}
      isEven={isEven}
      onClick={onSelect ? () => onSelect(field.id) : undefined}
    >
      <FieldTitle field={field} />
      <AnnotationIndicators attachments={field.attachments} />
      <FieldFeedbackBadge fieldId={field.id} size="small" />
      <NumericControl
        value={field.value}
        onChange={(v) => actions.patch({ value: v })}
        disabled={disabled}
        unit={unit}
      />
    </FieldWrapper>
  );
}
